export const caseInsensitiveInclude = (item: string, query: string) => {
	return item.toLowerCase().includes(query.toLowerCase());
};
